import type { IBusiness, IBusinessUser } from '@recargas-dominicanas/core/types';
import { Modal } from '../../../components/modal/modal.component';
import { style } from './added-business-modal.module.css';

interface Props {
  open: boolean;
  business: IBusiness & { businessUser?: IBusinessUser };
  onClose: () => void;
}

export function AddedBusinessModal(props: Props) {

  const {
    open,
    business,
    onClose
  } = props;

  return (
    <Modal
      style={style.modal}
      open={open}
      title='Negocio agregado'
      secondaryButton='Aceptar'
      onSecondaryClick={onClose}
      onClose={onClose}>
      <div className={style.item}>
        <div className={style.itemTitle}>Nombre</div>
        <div className={style.itemValue}>{business.name}</div>
      </div>
      {business.rnc &&
        <div className={style.item}>
          <div className={style.itemTitle}>RNC</div>
          <div className={style.itemValue}>{business.rnc}</div>
        </div>
      }
      {business.phone &&
        <div className={style.item}>
          <div className={style.itemTitle}>Teléfono</div>
          <div className={style.itemValue}>{business.phone}</div>
        </div>
      }
      {business.email && 
        <div className={style.item}>
          <div className={style.itemTitle}>Email</div>
          <div className={style.itemValue}>{business.email}</div>
        </div>
      }
      <div className={style.item}>
        <div className={style.itemTitle}>Ciudad</div>
        <div className={style.itemValue}>{business.city}</div>
      </div>
      <div className={style.item}>
        <div className={style.itemTitle}>Dirección</div>
        <div className={style.itemValue}>{business.address}</div>
      </div>
      <div className={style.item}>
        <div className={style.itemTitle}>Usuario</div>
        <div className={style.itemValue}>{business.businessUser?.userName}</div>
      </div>
      <div className={style.item}>
        <div className={style.itemTitle}>Contraseña</div>
        <div className={style.itemValue}>{business.businessUser?.password}</div>
      </div>
    </Modal>
  );
}
